// src/FocusModeContext.js
import React, { createContext, useContext, useState } from 'react';

const FocusModeContext = createContext();

 export const FocusModeProvider = ({ children }) => {
 const [focusMode, setFocusMode] = useState(
   localStorage.getItem('focusMode') === 'true'
 );
  const [ambientOn, setAmbientOnState] = useState(
    localStorage.getItem('ambientOn') === 'true'
  );

 const toggleFocusMode = () => {
   const next = !focusMode;
   setFocusMode(next);
   localStorage.setItem('focusMode', String(next));
   // If user turns Focus Mode ON, ensure ambient sound is enabled
   if (next && !ambientOn) {
     setAmbientOnState(true);
     localStorage.setItem('ambientOn', 'true');
   }
 };

  const setAmbientOn = (value) => {
    setAmbientOnState(value);
    localStorage.setItem('ambientOn', String(value));
  };

  return (
    <FocusModeContext.Provider
      value={{
        focusMode,
        toggleFocusMode,
        ambientOn,
        setAmbientOn, // ✅ must be exposed here
      }}
    >
      {children}
    </FocusModeContext.Provider>
  );
};


export const useFocusMode = () => useContext(FocusModeContext);
